<template>
  <div id="dividend-table-type-icon">
    <div class="items-flex">
      <v-tooltip top max-width="300px">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" :size="iconSize" :color="color" v-on="on">
            {{ icon }}
          </v-icon>
        </template>
        <span>
          {{ $t(`views.dividends.dividendModal.title.${item.type}`) }}
        </span>
      </v-tooltip>

      <TableImportIcon :item="item" />
    </div>
  </div>
</template>

<script>
import { DIVIDENDS_TYPE_PALETTE } from '@/lib/colors.js'
import TableImportIcon from '@/views/components/common/TableImportIcon'

export default {
  components: { TableImportIcon },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    icon() {
      if (this.item.type === 'stockDividend') return 'mdi-piggy-bank-outline'
      else if (this.item.type === 'coupon') return 'mdi-tag-text-outline'
      return null
    },
    iconSize() {
      return 18
    },
    color() {
      return DIVIDENDS_TYPE_PALETTE[this.item.type]
    },
  },
}
</script>

<style lang="scss">
#dividend-table-type-icon {
  .items-flex {
    display: flex;
    align-items: center;
  }
  .forked-icons {
    display: flex;
    flex-direction: column;
  }
}
</style>
